/* Lo Esencial — add-to-cart landing feedback (badge bump)
 *
 * HISTORY: this file used to fly a ghost of the product image along an arc
 * into the cart icon. That animation was removed on request (2026-07-30).
 * What remains is the quiet half: when the cart actually changes, the header
 * cart badge and the drawer's Carrito tab badge bump once.
 *
 * The bump is still gated on le:cart:updated and never on the click, so a
 * failed add (sold out, rejected bundle) cannot produce a confirmation for
 * something that did not happen.
 *
 * To restore the flight: git show wishlist-live-2026-07-30:assets/fly-to-cart.js
 */
(function () {
  'use strict';

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function bump() {
    if (reduceMotion()) return;

    // The header button is the primary target. The drawer's Carrito tab is
    // bumped too: once the drawer is open it covers the header, so without it
    // the feedback would be invisible on exactly the screen the customer is
    // looking at.
    //
    // The class goes on the BUTTON/TAB, not the badge, because
    // assets/cart-drawer.js updateCartCount() creates and removes the badge
    // span whenever the count crosses 0 -- a class on the badge would be
    // discarded mid-animation on the very first add.
    [
      document.querySelector('.site-header__action--cart'),
      document.querySelector('.cart-drawer__tabs [data-cart-view="cart"]')
    ].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-bump');
      void el.offsetWidth; // reflow so a repeat add re-triggers the keyframes
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 600);
    });
  }

  document.addEventListener('le:cart:updated', bump);
})();
